import styled from 'styled-components/macro'
import { ITheme } from 'styles/types'

export const Form = styled.form`
  text-align: left;
`

export const FormItem = styled.div`
  margin-bottom: 40px;

  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.sm} {
    margin-bottom: 20px;
  }
`
